import { reloadDatatable } from "../common/datatables";
import { openDialog, dialogModel } from "../common/dialog";

import http from "../../services/httpService";
import { openSnackbar, snackbarModel } from "../common/snackbar";

const props = {
    urlRedirectionManagementDatatableMarker: '.marker-url-redirection-management',
    urlRedirectionManagementDatatable: '#dt-url-redirection-management',
    searchterm_selector: '#SearchField',
    deleteItem: '.delete-url-redirection-item'
};

export function initDtAdminUrlRedirectionManagement() {

    if ($(props.urlRedirectionManagementDatatableMarker).length) {
        dtAdminUrlRedirectionManagement(initUrlRedirectionManagementDatatableEvents, props.searchterm_selector, props.urlRedirectionstatus_selector);
        setupUrlRedirectionManagementSearchEvents();
    }

}

const setupUrlRedirectionManagementSearchEvents = () => {

    //PURPOSE: initialises events associated with the text search field
    $(props.searchterm_selector).off("keypress").on('keypress', (e) => {
        if (e.which === 13) {
            e.preventDefault();

            reloadUrlRedirectionManagementDatatable();
        }
    });

    //PURPOSE: initialises search button click event
    $('.mdc-text-field__icon').off("click").on('click', (e) => {
        reloadUrlRedirectionManagementDatatable();
    });
};


const reloadUrlRedirectionManagementDatatable = () => {
    //PURPOSE: reloads datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.urlRedirectionManagementDatatable, initUrlRedirectionManagementDatatableEvents, true);
};

export function initUrlRedirectionManagementDatatableEvents() {

    //PURPOSE: sets up the full row click select for the dt
    $(props.urlRedirectionManagementDatatable).off('click').on('click', 'tbody td:not(.action)', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var urlRedirectionId = $(event.currentTarget).parent('tr').data('id');

        //window.open('/administration/urlredirectionmanagement/edit/' + urlRedirectionId, "_blank");

        window.location.href = '/administration/urlredirectionmanagement/edit/' + urlRedirectionId;
    });

    $(props.deleteItem).off('click').on('click', async function () {

        var urlRedirectionId = $(this).data('id');

        openDialog({
            ...dialogModel,
            title: 'Delete Item',
            content: 'Are you sure you want to delete this URL redirection item?',
            confirmButtonText: 'Delete',
            onConfirm: () => deleteUrlRedirection(urlRedirectionId),
            theme: 'delete'
        });
    });
}


function dtAdminUrlRedirectionManagement(onloadCallback, searchterm_selector) {

    if ($(props.urlRedirectionManagementDatatable).length === 0) return false;

    $(props.urlRedirectionManagementDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/urlredirectionmanagement/urlredirectionmanagementsearch',
            data: function (d) {
                d.searchterm = $(searchterm_selector).val();

            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'originalUrl', name: 'Original Url', class:"" },
            { data: 'redirectDomain', name: 'Redirect Domain' },
            { data: 'redirectPath', name: 'Redirect Path', class: "" },
            { data: 'clearQuerystring', name: 'Clear Querystring' },
            { data: 'redirectPermanent', name: 'Redirect Permanent' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<button data-id="' + o.id + '" type="button" class="delete-url-redirection-item mdc-button mdc-button--raised bg-red text-white min-width-80 hidden-xs mr-2">Delete</button>'
                },
                class: 'text-align-right action'
            },
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}


async function deleteUrlRedirection(urlRedirectionId) {

    const data = {
        id: urlRedirectionId
    };

    const result = await deleteUrlRedirectionService(data);

    reloadUrlRedirectionManagementDatatable();

    openSnackbar({
        ...snackbarModel,
        content: result.responseMessage
    });
}



async function deleteUrlRedirectionService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/urlredirectionmanagement/deleteurlredirection', data);

    // The response is an object with a property called 'data'. This contains the modal HTML.
    return response.data;
}